export enum EColors {
  ORANGE = '#ff8521',
  GREY = '#6e8b96',
  DARK_GREY = '#43545b',
  MEDIUM_GREY = '#85a4b0',
  LIGHT_GREY = '#d5dfe6',
  LIGHTER_GREY = '#DCDCDC',
  BRIGHT_GREY = '#f2f5f7',
  PALE_GREY = '#ebeef0',
  BLUE = '#087acb',
  LIGHT_BLUE = '#319dea',
  WHITE = '#fff',
  LIGHT_RED = '#e76a6a',
}

export enum EColorsName {
  GREY = 'grey',
  ORANGE = 'orange',
  DARK_GREY = 'dark_grey',
}
export type TColors = 'grey' | 'orange' | 'dark_grey'
